import { render, staticRenderFns } from "./DashboardJobStatus.vue?vue&type=template&id=0a7ff370&scoped=true"
import script from "./DashboardJobStatus.vue?vue&type=script&lang=js"
export * from "./DashboardJobStatus.vue?vue&type=script&lang=js"
import style0 from "./DashboardJobStatus.vue?vue&type=style&index=0&id=0a7ff370&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7ff370",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a7ff370')) {
      api.createRecord('0a7ff370', component.options)
    } else {
      api.reload('0a7ff370', component.options)
    }
    module.hot.accept("./DashboardJobStatus.vue?vue&type=template&id=0a7ff370&scoped=true", function () {
      api.rerender('0a7ff370', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/DashboardJobStatus.vue"
export default component.exports